export default __webpack_public_path__ + "static/media/tiendaFisica.e78066a1.svg";